import { gql } from 'graphql-request';
import { orchestrationLayerFetcher } from 'util/OL';
import { trackError } from 'util/error';

export const fetchCropList = (countryCode?: string) => {
  const query = gql`
  query Crops($useSprout: Boolean, $displayCrop: Boolean, $countryCode: String) {
    crops(displayCrop: $displayCrop, countryCode: $countryCode) {
      nodes {
        id
        name
        cropLegacyIds {
          id
          cropCode
        }
        nominalWeight(useSprout: $useSprout) {
          unit
          value
        }
      }
    }
  }`;
  

  const variables = {
    displayCrop: true,
    useSprout: true,
    countryCode
  };

  try {
    return orchestrationLayerFetcher(query, variables);
  } catch (error) {
    trackError(new TypeError('Could not fetch "Crops" query from OL'), { error, query, variables });
    throw error;
  }
};
